import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { IComboBase } from '../interfaces/base/base.interface';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class TypeDocumentService {
  private apiUrl = `${environment.apiUrl}/typeDocuments`;

  constructor(private http: HttpClient) {}

  comboTypeDocument(countryId: string): Observable<IComboBase[]> {
    return this.http.get<IComboBase[]>(this.apiUrl + '/combo/byCountry', {
      params: { countryId: countryId },
    });
  }
}
